import axios from "axios"

import { API_URL } from '../../config/appConfig';

export const AUTH_URL = `${API_URL}/api/Authenticate`;

export const getAccessKey = (userName: string) => {
  return axios.get(`${AUTH_URL}/getAccessKey?userName=${userName}`);
}

export const getAccessKeyPublic = () => {
  return axios.get(`${AUTH_URL}/getAccessKeyPublic`);
}

export const createAccessKey = (userName: string) => {
  return axios.post(`${AUTH_URL}/createAccessKey?userName=${userName}`, {});
}

export const createAccessKeyPublic = () => {
  return axios.post(`${AUTH_URL}/createAccessKeyPublic`, {});
}

export const deleteAccessKey = (userName: string) => {
  return axios.post(`${AUTH_URL}/deleteAccessKey?userName=${userName}`, {});
}

export const deleteAccessKeyPublic = () => {
  return axios.post(`${AUTH_URL}/deleteAccessKeyPublic`, {});
}

export const logout = () => {
  return axios.post(`${AUTH_URL}/logout`, {});
}

export const refreshToken = () => {
  return axios.post(`${AUTH_URL}/refreshtoken`, {});
}

export const verifyUser = (userName: string) => {
  return axios.post(`${AUTH_URL}/verifyUser?userName=${userName}`,  {});
}